module.exports = __webpack_public_path__ + "static/media/grimleys_desktop.1bc944df.png";